import request from '@/utils/request'

export function updateUser(users) {
  var data = users.data;
  return request({
    url: 'users/update/' + users.id,
    method: 'post',
    data
  })
}


export function show(id) {
  return request({
    url: 'users/' + id,
    method: 'get',
    id
  })
}

export function scheduleEvent(data) {
  return request({
    url: 'user/add',
    method: 'post',
    data
  })
}

export function checkRoom(data) {
  return request({
    url: 'check-room',
    method: 'post',
    data
  })
}
/**
 * on upload image for profile added on 29/09/2021
 * @param {*} param0 
 * @param {*} data 
 */
export function updateProfileImage(data) {
  var role = data.get('route_role');
  return request({
    url: 'update-' + role + '-profile-picture',
    method: 'post',
    data
  })

}
